<section class="page">
  <header class="page-header">
    <h2>Cartouches livrées en attente d'attribution</h2>
    <p class="subtitle">Liste les cartouches déjà livrées qui n'ont pas encore de groupe d'amorces attribué.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-analyses/attribution/attribuer">Aller vers attribution</a>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des cartouches livrées sans attribution...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucune cartouche livrée en attente d'attribution.</p>
    } @else {
      <p class="meta">{{ items.length }} cartouche(s) à attribuer.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.nom }}</td>
                <td>{{ item.statut_livraison_nom || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>